import { render, staticRenderFns } from "./ViewBusinessKyc.vue?vue&type=template&id=bc20aaf4"
import script from "./ViewBusinessKyc.vue?vue&type=script&lang=js"
export * from "./ViewBusinessKyc.vue?vue&type=script&lang=js"
import style0 from "./ViewBusinessKyc.vue?vue&type=style&index=0&id=bc20aaf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports